import { cn } from "@lib/cn"
import * as m from "@paraglide/messages"
import type { TextAreaProps } from "@site-types/sendMail"
import { FieldTooltip } from "../FieldTooltip"
import { extractErrorMessage } from "../fieldUtils"
import { useSendMailLang } from "../langContext"

export const TextArea = ({
  inputLabel,
  toolTip,
  inputProps,
  errorMessage,
  register,
  errors,
  rules,
}: TextAreaProps) => {
  const lang = useSendMailLang()
  const name = inputProps.name
  const id = inputProps.id || name
  const error = errors?.[name]
  const errorMsg = extractErrorMessage(errors, name, errorMessage)

  return (
    <div className="mb-8 flex flex-col border-[#ffffff30] border-t-2">
      <label
        className="py-4"
        htmlFor={id}
      >
        {inputLabel}
      </label>

      <div className="relative inline-block w-full">
        <FieldTooltip
          message={errorMsg}
          open={!!error && toolTip}
        >
          <textarea
            className={cn(
              "h-[118px] w-full",
              error && "outline-2 outline-[var(--pink)]",
              inputProps.className
            )}
            {...inputProps}
            id={id}
            {...(register ? register(name, rules) : {})}
          />
        </FieldTooltip>

        <small className="block py-2 text-[11px]">
          {m.contact_formMessage_textLimit({}, { locale: lang })}
        </small>
      </div>
    </div>
  )
}
